let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UVE8")).then(() => parcelRequire('amnsQ'));